// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-panel-bordered {\n  border-radius: 4px;\n  border: 1px solid #f4f4f4;\n  padding: 52px 24px 0px 24px;\n  margin-bottom: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
